<template>
  <div class="dhmap-wrapper">
    <map-locator :param="param" mode='h5'></map-locator>
  </div>
</template>

<script>
import mapLocator from "@/components/map/MapLocator"
export default {
  name: "locator",
  components: {mapLocator},
  props: {
    param: { type: Object, default: () => {return {}}},
    mode: { type: String, default: "web" }
  },
  data() {
    return {

    }
  },
  mounted(){
  
  },
  methods:{

  },
  computed:{
      
  }
}
</script>

<style scoped>
.dhmap-wrapper{
  width:100%;
  height: 100%;
}
</style>